var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNorealtime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 42 42",
    width: 42,
    height: 42,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1",
    "data-name": "Pfad 1",
    d: "M40,20A20,20,0,1,1,20,0,20,20,0,0,1,40,20Z",
    transform: "translate(0 0)",
    fill: "#353535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2",
    "data-name": "Pfad 2",
    d: "M25.481,11.843a9.993,9.993,0,0,0-10,9.992c0,7.773,10,14.8,10,14.8s9.992-7.5,9.992-14.8a9.991,9.991,0,0,0-9.992-9.992m0,14.662a4.924,4.924,0,1,1,4.924-4.924A4.93,4.93,0,0,1,25.482,26.5",
    transform: "translate(-5.477 -4.19)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3",
    "data-name": "Pfad 3",
    d: "M12.015,8.124,38.081,34.031,35.4,36.536,9.06,10.527Z",
    transform: "translate(-3.206 -2.874)",
    fill: "#ec0016"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4",
    "data-name": "Pfad 4",
    d: "M20,3.231A16.769,16.769,0,1,1,3.231,20,16.788,16.788,0,0,1,20,3.231M20,0A20,20,0,1,0,40,20,20,20,0,0,0,20,0",
    transform: "translate(0 0)",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorealtime);
export default __webpack_public_path__ + "static/media/norealtime.13c55c1d8ec0ca4229e29fe1a047b86f.svg";
export { ForwardRef as ReactComponent };